import { render, staticRenderFns } from "./MilitaryStatusTypeDelete.vue?vue&type=template&id=c5358fc4&"
import script from "./MilitaryStatusTypeDelete.vue?vue&type=script&lang=js&"
export * from "./MilitaryStatusTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports